import { render } from "./DoctorForm.vue?vue&type=template&id=687065f4"
import script from "./DoctorForm.vue?vue&type=script&lang=js"
export * from "./DoctorForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__